export { HeaderOwndaysProgressiveCP } from './HeaderOwndaysProgressiveCP';
export { BodyOwndaysProgressiveCP } from './BodyOwndaysProgressiveCP';
export { FooterOwndaysProgressiveCP } from './FooterOwndaysProgressiveCP';
